import { createSlice } from "@reduxjs/toolkit";
import { clearAppError } from "./globalActions";

type WsStatus = "online" | "offline" | "idle";

const initialState: {
  is_loading: boolean;
  error: any;
  is_page_loading: boolean;
  ws_status: WsStatus;
} = {
  is_loading: false,
  error: null,
  is_page_loading: false,
  ws_status: "offline",
};

export const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    startLoading: (state) => {
      state.is_loading = true;
    },
    stopLoading: (state) => {
      state.is_loading = false;
    },
    startPageLoading: (state) => {
      state.is_page_loading = true;
    },
    stopPageLoading: (state) => {
      state.is_page_loading = false;
    },
    setWsStatus: (state, action) => {
      state.ws_status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAppError, (state, action) => {
      if (action.payload && state.error && action.payload in state.error) {
        delete state.error[action.payload];
      } else {
        state.error = null;
      }
    });
  },
});

export const commonActions = commonSlice.actions;

export const { reducer: commonReducer } = commonSlice;

export default commonReducer;
